module.exports = __webpack_public_path__ + "img/p6.450aa3f6.png";